var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar", [
        _c(
          "div",
          {
            staticClass: "flex-2 text-center",
            attrs: { slot: "title" },
            slot: "title",
          },
          [
            _vm._v(
              _vm._s(_vm.$t("products.navTitle")) +
                "（" +
                _vm._s(_vm.cartItems.length) +
                "）"
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "pt-2" }, [
        _vm.cartItems.length > 0
          ? _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center p-3 bg-white mb-2 mx-4 rounded-lg",
                  },
                  [
                    _c("van-icon", {
                      attrs: {
                        name: _vm.isAllSelected ? "checked" : "circle",
                        color: "#ff7a00",
                        size: "20",
                      },
                      on: { click: _vm.toggleSelectAll },
                    }),
                    _c("span", { staticClass: "ml-2 text-base" }, [
                      _vm._v(_vm._s(_vm.$t("products.selectAll"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "items-center hidden md:flex text-base" },
                      [
                        _c("span", [
                          _vm._v("（" + _vm._s(_vm.cartItems.length) + "）"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._l(_vm.cartItems, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.sku,
                      staticClass:
                        "flex items-center py-3 px-3 bg-white mb-2 mx-4 rounded-lg",
                    },
                    [
                      _c(
                        "van-swipe-cell",
                        {
                          staticClass: "w-full",
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "right",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-center h-full",
                                      },
                                      [
                                        _c("van-button", {
                                          staticClass: "h-full",
                                          attrs: {
                                            square: "",
                                            type: "danger",
                                            text: _vm.$t("address.delete"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeItem(item)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center" },
                            [
                              _c("van-icon", {
                                attrs: {
                                  name: _vm.selectedIds.includes(item.id)
                                    ? "checked"
                                    : "circle",
                                  color: "#ff7a00",
                                  size: "20",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleItemSelect(item)
                                  },
                                },
                              }),
                              _c("img", {
                                staticClass:
                                  "w-16 h-16 rounded-lg flex-shrink-0 mr-2 ml-2",
                                attrs: { src: item.picUrl },
                              }),
                              _c("div", { staticClass: "flex-1" }, [
                                _c(
                                  "h3",
                                  { staticClass: "text-base font-medium mb-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isZh ? item.region : item.regionEn
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "text-sm text-gray-500 mb-2" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.isZh
                                            ? item.selectedText +
                                                (item.day > 1
                                                  ? _vm.$t("products.days")
                                                  : _vm.$t("products.day"))
                                            : item.selectedTextEn +
                                                (item.day > 1
                                                  ? _vm.$t("products.days")
                                                  : _vm.$t("products.day"))
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-between",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center flex-row",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-gray-400 line-through",
                                          },
                                          [
                                            _vm._v(
                                              "RM" +
                                                _vm._s(
                                                  _vm.formatToYuan(
                                                    item.marketPrice
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-1 text-base font-bold text-[#ff7a00]",
                                          },
                                          [
                                            _vm._v(
                                              "RM " +
                                                _vm._s(
                                                  _vm.formatToYuan(item.price)
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center border border-gray-200 rounded px-2 py-1",
                                          },
                                          [
                                            item.count === 1
                                              ? _c("van-icon", {
                                                  attrs: {
                                                    name: "delete",
                                                    size: "16",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeItem(
                                                        item
                                                      )
                                                    },
                                                  },
                                                })
                                              : _c("van-icon", {
                                                  attrs: {
                                                    name: "minus",
                                                    size: "16",
                                                    color: "black",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDecrease(
                                                        item
                                                      )
                                                    },
                                                  },
                                                }),
                                            _c(
                                              "span",
                                              { staticClass: "mx-2 text-sm" },
                                              [_vm._v(_vm._s(item.count))]
                                            ),
                                            _c("van-icon", {
                                              attrs: {
                                                name: "plus",
                                                size: "16",
                                                color: "black",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.increaseQuantity(
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "hidden md:block ml-3 rounded-md text-sm text-gray-900",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("address.delete")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          : _c(
              "div",
              {
                staticClass: "flex flex-col items-center justify-center mt-20",
              },
              [
                _c("van-empty", {
                  attrs: { description: _vm.$t("products.cardEmpty") },
                }),
              ],
              1
            ),
      ]),
      _vm.cartItems.length > 0
        ? _c("div", { staticClass: "mx-4 mt-4" }, [
            _c("div", { staticClass: "bg-white rounded-lg p-3 px-2" }, [
              _c("div", { staticClass: "space-y-2 text-sm" }, [
                _c("div", { staticClass: "flex items-center" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("products.cardDesc1")))]),
                ]),
                _c("div", { staticClass: "flex items-center" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("products.cardDesc2")))]),
                ]),
                !_vm.isLoggedIn
                  ? _c(
                      "div",
                      { staticClass: "flex items-center" },
                      [
                        _c("span", { staticClass: "text-[#ff7a00]" }, [
                          _vm._v(
                            _vm._s(_vm.$t("products.cardDesc3")) +
                              _vm._s(_vm.newReward) +
                              _vm._s(_vm.$t("products.cardDesc8"))
                          ),
                        ]),
                        _c(
                          "van-button",
                          {
                            staticClass: "ml-2 w-20",
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              color: "#ff7a00",
                            },
                            on: { click: _vm.handleLogin },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("products.cardBtnText1")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "h-26" }),
      _vm.cartItems.length > 0
        ? _c(
            "div",
            {
              class: [
                " fixed bottom-0 left-0 right-0  yoyo-container mx-auto h-19 ",
                ,
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex h-full z-50 items-center pr-2 w-full lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-2",
                },
                [
                  _vm.selectedIds.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex-1 text-right mr-4 flex flex-col justify-between",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-base font-bold text-[#ff7a00]",
                            },
                            [
                              _vm._v(
                                "RM " +
                                  _vm._s(
                                    _vm.formatToYuan(_vm.selectedTotalAmount)
                                  )
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "text-sm text-gray-500" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("products.cardDesc5")) +
                                " " +
                                _vm._s(_vm.selectedTotalGivePoint.point) +
                                " " +
                                _vm._s(_vm.$t("products.cardDesc6")) +
                                "，" +
                                _vm._s(_vm.$t("products.cardDesc7")) +
                                _vm._s(_vm.selectedTotalGivePoint.pointPrice) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex-1" }),
                  _c(
                    "van-button",
                    {
                      staticClass: "rounded-xl w-20 h-10",
                      attrs: {
                        type: "primary",
                        color: "#ff7a00",
                        disabled: _vm.totalCount === 0,
                      },
                      on: { click: _vm.checkout },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("products.cardBtnText2")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }